// Aceleres — indicador visual de origem da conversa/contato (o canal).
//
// Este mapa nasceu dentro do ConversationCard e passou a viver aqui quando a
// carteirização precisou do MESMO desenho: duas cópias significariam um canal
// novo aparecendo na lista de conversas e não na carteira, ou pintado de outra
// cor nas duas telas.
//
// A chave é o channel_type puro, sem regra em volta: canal novo só precisa de
// uma linha aqui para as duas telas passarem a mostrar ícone e tooltip.
// Instagram e Facebook chegam como inbox própria desde a migração para a WAME,
// por isso o mapa é por channel_type e não por "WhatsApp x resto".
//
// A cor é o hex da marca, não token do tema: neste tema `n-blue-11` resolve
// para verde e `n-green` nem existe, então o token pintaria o Facebook da cor
// errada. Os mesmos hex estão no card do funil (board-styles.blade.php) para
// os dois produtos ficarem idênticos.
export const CANAL_INDICADORES = {
  'Channel::Whatsapp': {
    label: 'WhatsApp Oficial',
    kind: 'oficial',
    icon: 'i-ri-whatsapp-fill',
    color: 'text-[#1da851] dark:text-[#25d366]',
  },
  'Channel::Api': {
    label: 'WhatsApp Corporativo',
    kind: 'corporativo',
    icon: 'i-ri-whatsapp-fill',
    color: 'text-[#1da851] dark:text-[#25d366]',
  },
  'Channel::Instagram': {
    label: 'Instagram',
    kind: 'instagram',
    icon: 'i-ri-instagram-fill',
    color: 'text-[#d6247a] dark:text-[#f06ba8]',
  },
  'Channel::FacebookPage': {
    label: 'Facebook',
    kind: 'facebook',
    icon: 'i-ri-facebook-circle-fill',
    color: 'text-[#1877f2] dark:text-[#4a97ff]',
  },
  'Channel::Linkedin': {
    label: 'LinkedIn',
    kind: 'linkedin',
    icon: 'i-ri-linkedin-box-fill',
    color: 'text-[#0a66c2] dark:text-[#4b9fe1]',
  },
  // Grafia alternativa: o model ainda não existe e a convenção do Rails admite
  // as duas. Registrar as duas evita card sem ícone se o canal nascer assim.
  'Channel::LinkedIn': {
    label: 'LinkedIn',
    kind: 'linkedin',
    icon: 'i-ri-linkedin-box-fill',
    color: 'text-[#0a66c2] dark:text-[#4b9fe1]',
  },
  'Channel::Telegram': {
    label: 'Telegram',
    kind: 'telegram',
    icon: 'i-ri-telegram-fill',
    color: 'text-[#229ed9] dark:text-[#4fc0f0]',
  },
  'Channel::WebWidget': {
    label: 'Chat do site',
    kind: 'site',
    icon: 'i-ri-global-fill',
    color: 'text-[#7c3aed] dark:text-[#a78bfa]',
  },
};

// Canal desconhecido devolve null de propósito: melhor nenhum ícone do que um
// ícone genérico que o gestor leria como "é esse canal aqui".
export const indicadorDeCanal = channelType =>
  CANAL_INDICADORES[channelType] || null;

// Lista de indicadores para um contato que fala por mais de uma conexão.
//
// Agrupa pelo DESENHO, não pelo channel_type: WhatsApp Oficial e Corporativo
// têm o mesmo ícone e a mesma cor, então listá-los separados desenharia dois
// ícones verdes idênticos colados — que se lê como falha de renderização, não
// como "este contato fala pelas duas conexões". Um ícone só, e o tooltip diz
// quais são. É o caso de 116 contatos desta base.
//
// A ordem é a do mapa, para dois contatos com os mesmos canais não desenharem
// os ícones em ordens diferentes.
const ORDEM = Object.keys(CANAL_INDICADORES);

export const indicadoresDeCanais = channelTypes => {
  const porDesenho = new Map();

  // Payload antigo (aba aberta antes do deploy) nao traz o campo; um contato
  // sem canal nenhum e caso normal — lead importado que nunca falou.
  (Array.isArray(channelTypes) ? channelTypes : [])
    .filter(type => CANAL_INDICADORES[type])
    .sort((a, b) => ORDEM.indexOf(a) - ORDEM.indexOf(b))
    .forEach(type => {
      const canal = CANAL_INDICADORES[type];
      const chave = `${canal.icon}|${canal.color}`;
      const atual = porDesenho.get(chave);

      if (!atual) {
        porDesenho.set(chave, { ...canal, key: chave, labels: [canal.label] });
        return;
      }
      if (!atual.labels.includes(canal.label)) atual.labels.push(canal.label);
    });

  return [...porDesenho.values()].map(canal => ({
    ...canal,
    label: canal.labels.join(' · '),
  }));
};
